export default __webpack_public_path__ + "static/media/revenue_red.ee08b1c4.svg";